<template>
  <div class="app">
    <DefaultHeader />
    <div class="app-body">
      <AppSidebar fixed>




        <SidebarHeader>

          <div align="center" class="pt-4 pb-3">
            <router-link to="/myprofile">
              <img v-if="image" :src="image" class="circular--square"
                style="text-align:center!important;width:100px;height:100px" alt="user_image" />
              <img v-else src="../assets/user.png" class="img-avatar" alt="image"
                style="text-align:center!important;width:100px;height:100px" />
            </router-link>
            <div align="center" class="pt-3">
              <router-link to="/myprofile">
                <b-button class="pl-4 pr-4 pt-0 pb-0 " variant="success">My Profile</b-button>
              </router-link>
            </div>

          </div>
        </SidebarHeader>
        <SidebarForm />
        <SidebarNav :navItems="nav">

        </SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <DefaultFooter />
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  Breadcrumb
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import DefaultHeader from "./DefaultHeader";
import DefaultFooter from "./DefaultFooter";

export default {
  name: "DefaultContainer",
  components: {
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader
  },
  data() {
    return {
      nav: nav.items,
      username: localStorage.getItem("username"),
      oldpassword: '',
      password: '',
      image: '',
    };
  },

  mounted: function () {
    this.getview();
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
  },

  methods: {
    getview() {
      this.visible = true
      axios({
        method: 'GET',
        url: '/user/profile',
        params: { 'token': localStorage.getItem('token') }
      })
        .then(response => {
          if (response.data.status === true) {
            if (response.data.data.photo != null) {
              this.image = imageURL + response.data.data.photo
            }



            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch(err => {
          this.errors.push(err)
          alert('No Network Found!!')
        })
    },
  }

};
</script>
<style scoped>
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
</style>